import React, { useEffect, useState } from 'react';
import SimpleLoader from 'components/loader/SimpleLoader';
import useDataset from './hooks/useDataset';
import FailedInProgressDataset from './components/FailedInProgressDataset';
import DatasetContent from './components/DatasetContent';

const DatasetView = () => {
    const [status, setStatus] = useState<string>('');

    const { dataset, isUserAdmin, error, getStackStatus, loading } =
        useDataset();

    useEffect(() => {
        setStatus(dataset.stack.status);
    }, [dataset]);

    useEffect(() => {
        const interval = setInterval(async () => {
            const stack = await getStackStatus();
            setStatus(stack);
        }, 10000);

        return () => clearInterval(interval);
    }, [getStackStatus]);

    return (
        <div>
            {loading ? (
                <SimpleLoader />
            ) : (
                !error &&
                (status === '' ||
                status === 'CREATE_IN_PROGRESS' ||
                status === 'ROLLBACK_IN_PROGRESS' ||
                status === 'REVIEW_IN_PROGRESS' ||
                status === 'CREATE_FAILED' ||
                status === 'DELETE_FAILED' ? (
                    <FailedInProgressDataset
                        dataset={dataset}
                        status={status}
                    />
                ) : (
                    <DatasetContent
                        // dataset={dataset}
                        status={status}
                        isUserAdmin={isUserAdmin}
                    />
                ))
            )}
        </div>
    );
};

export default DatasetView;
